<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_WKCLDR_UPSERT_WKCLDR')">
    <div class="breadcrumb-area pos-relative">
      <h1 v-if="$route.params.id">Sửa lịch làm việc</h1>
      <h1 v-else>Thêm mới lịch làm việc</h1>
      <div class=" " style="float: right">
        <button class="btn btn-light" @click="$router.push('/calendar')">Hủy bỏ</button>
        <button class="btn btn-success btn-primary ml-2" @click="onSubmit">
          {{ $route.params.id ? 'Cập nhật' : 'Thêm mới' }}
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 row">
        <ValidationObserver ref="calendarAdd" class="d-flex w-100">
          <form class="col-md-6" @submit.prevent="onSubmit">
            <h1 class="form-inner-heading mb-2">Thông tin</h1>
            <ValidationProvider rules="required" vid="classify" name="Phân loại">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label"
                  >Phân loại <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    :disabled="!!$route.params.id || $route.query.purposeType"
                    @change="handleChangeClassify"
                    v-model="submitData.purposeType"
                    :options="Config.jobClassify"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              rules="required"
              vid="merchantName"
              name="Merchant"
              v-if="submitData.purposeType === 'MERCHANT'"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Merchant <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input type="hidden" class="form-control text-left" v-model="merchantSelected" />
                  <input
                    :disabled="!!$route.params.id || $route.query.customerId"
                    type="text"
                    class="form-control text-left"
                    :value="merchantSelected.merchantName ? `${merchantSelected.merchantName}` : ''"
                    readonly
                    placeholder="Chọn merchant"
                    v-b-modal.select-merchant-dialog
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              vid="leadName"
              name="Lead"
              v-if="submitData.purposeType === 'LEAD'"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Lead <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input type="hidden" class="form-control text-left" v-model="leadSelected" />
                  <input
                    :disabled="!!$route.params.id || $route.query.leadId"
                    type="text"
                    class="form-control text-left"
                    :value="leadSelected.merchantName ? `${leadSelected.merchantName}` : ''"
                    readonly
                    placeholder="Chọn Lead"
                    v-b-modal.select-lead-dialog
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              rules="required"
              vid="address"
              name="Điểm hẹn"
              v-if="submitData.purposeType !== 'LEAD'"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label"
                  >Điểm hẹn <span style="color: red"> * </span></label
                >
                <div class="col-sm-7">
                  <b-form-input type="text" v-model="submitData.address"></b-form-input>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row" v-if="submitData.purposeType !== 'LEAD'">
              <label for="" class="col-sm-3 col-form-label"> Độ ưu tiên </label>
              <div class="col-sm-7">
                <Select2 v-model="submitData.isPeriod" :options="listPriority" name="staff" />
              </div>
            </div>

            <div class="form-group row" v-if="submitData.purposeType !== 'LEAD'">
              <label for="" class="col-sm-3 col-form-label">Nhân viên xử lý</label>
              <div class="col-sm-7">
                <Select2 v-model="submitData.staff" :options="listStaff" name="staff" />
              </div>
            </div>

            <ValidationProvider
              rules="required"
              vid="statusWkcldr"
              name="Trạng thái"
              v-if="submitData.purposeType === 'LEAD'"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label"
                  >Trạng thái <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    :disabled="!!$route.params.id || $route.query.statusWkcldr"
                    v-model="submitData.statusWkcldr"
                    :options="Config.statusWkcldr.filter(s => s.id !== 'DELETED')"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              rules="requiredDate|dateRangeInOneDay"
              name="Thời gian"
              v-if="
                submitData.purposeType !== 'LEAD' ||
                (submitData.purposeType === 'LEAD' && submitData.statusWkcldr === 'NOT_PROCESS')
              "
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label"
                  >Thời gian dự kiến <span style="color: red"> * </span>
                </label>
                <div class="col-sm-7">
                  <InputRange v-model="dateRange"></InputRange>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="cat" name="Mục đích">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label"
                  >Mục đích <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2 v-model="submitData.cat" :options="listCat" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              vid="kq"
              name="Kết quả"
              v-if="submitData.purposeType === 'LEAD' && submitData.statusWkcldr === 'PROCESSED'"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label"
                  >Kết quả <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2 v-model="submitData.result" :options="listResult" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              rules="required"
              vid="exeDate"
              name="Thời gian liên hệ"
              v-if="submitData.purposeType === 'LEAD' && submitData.statusWkcldr === 'PROCESSED'"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label">
                  Thời gian liên hệ <span style="color: red">*</span>
                </label>
                <div class="col-sm-7">
                  <DateTimePicker
                    v-model="submitData.exeDate"
                    :config="{ format: 'DD-MM-YYYY HH:mm', useCurrent: true }"
                  ></DateTimePicker>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row d-flex">
              <label for="" class="col-sm-3 col-form-label">Ghi chú</label>
              <div class="col-sm-7">
                <b-form-input type="text" v-model="submitData.depcription"></b-form-input>
              </div>
            </div>
          </form>
          <div class="col-md-6">
            <UploadMultiple
              @syncFile="syncFile"
              :lsData="fileUploads"
              maxFil="100"
              uniqueKey="images"
              title="Ảnh"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
            <UploadMultiple
              :lsData="fileCheckin"
              uniqueKey="images"
              :canUpload="false"
              title="Ảnh checkin"
              titleTag="h1"
              titleClass="form-inner-heading"
            />
          </div>
        </ValidationObserver>
      </div>
    </div>

    <SelectMerchant @selectMerchant="onSelectMerchant" />
    <SelectLead @selectLead="onSelectLead" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'
  import { CalendarService } from '@/services/calendar.service'
  import { StaffService } from '@/services/staff.service'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { mapGetters } from 'vuex'
  import { v4 as uuidv4 } from 'uuid'
  import { MerchantService } from '@/services/merchant.service'
  import InputRange from '@/components/InputRange.vue'
  import Config from '@/thirdParty/config'
  import SelectMerchant from '@/components/SelectMerchant.vue'
  import SelectLead from '@/components/SelectLead.vue'
  import { LeadsService } from '@/services/lead.service'

  export default {
    components: { InputRange, SelectMerchant, UploadMultiple, SelectLead },
    data() {
      return {
        Config,
        submitData: {
          staff: null,
          depcription: null,
          merchant: null,
          cat: null,
          address: null,
        },
        listStaff: [],
        listCat: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dateRange: {
          startDate: null,
          endDate: null,
        },
        customerIdQuery: this.$route.query.customerId ? this.$route.query.customerId : null,
        merchantSelected: {},
        leadSelected: {},
        listPriority: [
          { id: true, text: 'Ưu tiên' },
          { id: false, text: 'Không ưu tiên' },
        ],
        showLoading: false,
        fileUploads: [],
        fileCheckin: [],
      }
    },

    created() {
      if (this.$route.params.id) this.fetchData()
      this.fetchDataStaff()
      if (this.customerIdQuery) this.fetchDataMC()
      if (this.$route.query.leadId) this.fetchDataLead()
      if (this.$route.query.purpose) {
        this.submitData.cat = this.$route.query.purpose
      }
      if (this.$route.query.statusWkcldr) {
        this.submitData.statusWkcldr = this.$route.query.statusWkcldr
      }
      if (this.$route.query.purposeType) {
        this.submitData.purposeType = this.$route.query.purposeType
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        allConfig: 'common/allConfig',
      }),
      listResult() {
        return (
          this.allConfig.purposes
            .find(s => s.code === this.submitData.cat)
            ?.purposesStatus?.map(item => ({ id: item.code, text: item.name })) ?? []
        )
      },
    },

    methods: {
      async fetchData() {
        try {
          const { data } = await CalendarService.getById({ id: this.$route.params.id })
          this.submitData = data
          this.submitData.cat = data.leadAction ?? data.cat
          this.handleChangeClassify(data.purposeType)
          this.merchantSelected.merchantName = data.merchantInforRes
            ? data.merchantInforRes?.merchantName
            : data.leadInfoRes?.merchantName
          this.leadSelected.merchantName = data.merchantInforRes
            ? data.merchantInforRes?.merchantName
            : data.leadInfoRes?.merchantName
          this.submitData.customerId = data.merchantInforRes
            ? data.merchantInforRes?.id
            : data.leadInfoRes?.leadId
          this.submitData.address = data.address
          this.submitData.staff = data.saleInfo.id
          this.dateRange.startDate = data.startTime
          this.dateRange.endDate = data.endTime
          this.dataUploadImage = data.urlImage
          this.fileUploads = data.urlImage.map(s => ({ url: s, id: uuidv4() }))
          this.fileCheckin = data.checkinImage
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      handleChangeClassify(e) {
        this.listCat = this.allConfig.purposes
          .filter(s => s.type === e)
          .map(item => ({ id: item.code, text: item.name }))
      },
      async fetchDataStaff() {
        try {
          this.showLoading = true
          const staffReponse = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          this.listStaff = staffReponse.data.map(item => {
            return { id: item.userId, text: `${item.name} - ${item.userName}` }
          })
          this.submitData.staff = this.dataUser.userId
        } catch (error) {
          console.log(error)
          this.showLoading = false
        } finally {
          this.showLoading = false
        }
      },

      async onSubmit() {
        const isSuccess = await this.$refs.calendarAdd.validate()
        if (!isSuccess) {
          return
        }
        try {
          this.showLoading = true
          let data = {}
          const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
          if (this.submitData.purposeType !== 'LEAD') {
            const params = {
              purposeType: this.submitData.purposeType,
              address: this.submitData.address,
              isPeriod: this.submitData.isPeriod,
              cat: this.submitData.cat,
              depcription: this.submitData.depcription,
              customerId: this.submitData.customerId,
              userId: this.submitData.staff
                ? this.submitData.staff.split('|')[0]
                : JSON.parse(localStorage.getItem('userData')).userId,
              saleName: this.submitData.staff
                ? this.submitData.staff.split('|')[1]
                : JSON.parse(localStorage.getItem('userData')).name,
              startTime: moment(this.dateRange.startDate).toISOString(),
              endTime: moment(this.dateRange.endDate).toISOString(),
              urlImage: files.map(s => s.urlFile),
              checkinImage: this.fileCheckin,
            }
            if (this.submitData.purposeType === 'OTHER') delete params.customerId
            if (this.$route.params.id) params.id = this.$route.params.id
            data = await CalendarService.upsert(params)
          } else {
            const params = {
              purposeType: this.submitData.purposeType,
              leadId: this.submitData.leadId,
              action: this.submitData.cat,
              statusWkcldr: this.submitData.statusWkcldr,
              note: this.submitData.depcription,
              actionImgs: files.map(s => s.urlFile),
            }
            if (this.submitData.statusWkcldr === 'PROCESSED') {
              params.result = this.submitData.result
              params.exeDate = moment(this.submitData.exeDate, 'DD-MM-YYYY HH:mm').valueOf()
            } else {
              params.startTime = moment(this.dateRange.startDate).valueOf()
              params.endTime = moment(this.dateRange.endDate).valueOf()
            }
            if (this.$route.params.id) params.wkcldrId = this.$route.params.id
            if (this.$route.params.id) data = await CalendarService.updateLead(params)
            else data = await CalendarService.createLead(params)
          }
          if (data.success) {
            this.showSuccessMx(
              this.$route.params.id ? 'Sửa thành công' : 'Thêm mới thành công'
            ).then(s =>
              this.$router.push(
                `/calendar/detail?id=${this.$route.params.id ?? data.data?.id ?? data.data?.wkcldrId}`
              )
            )
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },

      onSelectMerchant(mc) {
        this.merchantSelected = mc
        this.submitData.customerId = mc.customerId
        this.submitData.address = mc.address
      },
      onSelectLead(lead) {
        this.leadSelected = lead
        this.submitData.leadId = lead.leadId
      },

      async fetchDataMC() {
        try {
          const response = await MerchantService.merchantDetail({
            customerId: this.customerIdQuery,
          })
          const { data } = response
          if (response.success) {
            this.onSelectMerchant(data)
            this.submitData.purposeType = 'MERCHANT'
            this.handleChangeClassify(this.submitData.purposeType)
          }
        } catch (error) {}
      },
      async fetchDataLead() {
        try {
          const response = await LeadsService.detailLead({
            leadId: this.$route.query.leadId,
          })
          const { data } = response
          if (response.success) {
            this.onSelectLead(data)
            this.submitData.purposeType = 'LEAD'
            this.handleChangeClassify(this.submitData.purposeType)
          }
        } catch (error) {}
      },
      syncFile(files) {
        this.fileUploads = files
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
    },
  }
</script>
<style scoped>
  .pos-relative {
    width: 100%;
  }
</style>
